import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-splitter',
    templateUrl: './splitter.component.html',
    styleUrls: ['./splitter.component.scss'],
    standalone: false
})
export class SplitterComponent implements OnInit {

  constructor(
    private router : Router,
  ) { }

  ngOnInit(): void {
  }

  isLogin(){return this.router.url.includes("login");}
  isDashboard(){return this.router.url.includes("dashboard");}

}
